import { Loader2, Inbox } from "lucide-react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
      <div>
        <h1 className="font-head text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">{title}</h1>
        {subtitle && <p className="text-slate-500 text-sm mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm ${className}`} {...rest}>{children}</div>;
}

const STATUS_STYLES = {
  verified: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  published: "bg-emerald-50 text-emerald-700 border-emerald-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  awaiting_payment: "bg-amber-50 text-amber-700 border-amber-200",
  awaiting_remaining: "bg-amber-50 text-amber-700 border-amber-200",
  partial: "bg-blue-50 text-blue-700 border-blue-200",
  requires_review: "bg-amber-50 text-amber-700 border-amber-200",
  under_review: "bg-amber-50 text-amber-700 border-amber-200",
  paused: "bg-amber-50 text-amber-700 border-amber-200",
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  archived: "bg-slate-100 text-slate-500 border-slate-200",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
  duplicate: "bg-rose-50 text-rose-700 border-rose-200",
  incorrect_amount: "bg-rose-50 text-rose-700 border-rose-200",
  invalid_destination: "bg-rose-50 text-rose-700 border-rose-200",
  closed: "bg-rose-50 text-rose-700 border-rose-200",
};

export function StatusBadge({ status }) {
  const label = (status || "").replace(/_/g, " ");
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border capitalize ${cls}`}>{label}</span>;
}

export function Loading() {
  return <div className="flex items-center justify-center py-20"><Loader2 className="w-7 h-7 animate-spin text-blue-600" /></div>;
}

export function Empty({ label = "Nothing here yet" }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-slate-400">
      <Inbox className="w-10 h-10 mb-3" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export const inputCls = "w-full bg-slate-50 border border-slate-300 rounded-lg px-3.5 py-2.5 text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all";
export const labelCls = "block text-xs font-semibold text-slate-700 uppercase tracking-wider mb-1.5";
export const btnPrimary = "bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 px-4 rounded-xl shadow-md shadow-blue-500/20 active:scale-[0.99] transition-all flex items-center justify-center gap-2 disabled:opacity-60 cursor-pointer";
export const btnSecondary = "bg-slate-100 hover:bg-slate-200 text-slate-800 font-medium py-2.5 px-4 rounded-xl border border-slate-200 transition-all flex items-center justify-center gap-2 cursor-pointer";
